import { __ } from 'i18n-for-browser'
import '../config/i18n'
import { logMsg, logAlert } from './easybake'
import { generateRsaKeyPair } from "./utils"

const FormData = require('form-data')
const axios = require('axios')

import { 
    STATUS_CODE_SUCCESS_CREATED,
    STATUS_CODE_SUCCESS_OK,
    STATUS_CODE_FAIL_CONFLICT
} from './constants'

// Get org
export async function getOrgs (ut) {
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations`,
            headers: getHeader(ut)
        }
        const orgs = await axios(config)

        const newOrgsData = []
        orgs.data.forEach( org => {
            if (org.imsType !== 'direct') {
                org.label = `${org.name} (${org.role})`
                org.value = org.id
                org.selected = false
                newOrgsData.push(org)
            }
        })
        if (newOrgsData && newOrgsData.length > 0) {
            newOrgsData[0].selected = true
            orgs.data = newOrgsData
            logMsg(null, orgs, 'getOrgs')
            return {
                error: null,
                response: orgs
            }
        } else {
            return {
                error: __("console_create_error_org_not_found"),
                response: null
            }
        }
    } catch(e) {
        return {
            error: e,
            response: null
        }
    }
}

// Get integrations
export async function getIntegrations (orgId, ut) {
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/integrations`,
            headers: getHeader(ut),
            qs: {page: 1, size: 50}
        }
        const ints = await axios(config)
        const newInts = ints.data.content.map( integration => {
            integration.label = `${integration.name} (${integration.apiKey})`
            integration.value = integration.id
            integration.selected = false
            return integration
        })
        // if (newInts && newInts.length > 0) {
        //     newInts[0].selected = true
        // }
        logMsg(null, newInts, 'getIntegrations')
        return {
            error: null,
            response: newInts
        }
    } catch(e) {
        return {
            error: e,
            response: null
        }
    }
}

// Check Developer Terms Acceptance
export async function checkTerms (ut, orgId) {
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/services/ims/organizations/${orgId}/terms`,
            headers: getHeader(ut)
        }
        const response = await axios(config)
        logMsg(null, response, 'checkTerms')
        return {
            error: null,
            response: response
        }
    } catch(e) {
        return {
            error: e,
            response: null
        }
    }
}

export async function acceptTerms (ut, orgId) {
    try {
        const config = {
            method: 'POST',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/services/ims/organizations/${orgId}/terms`,
            headers: getHeader(ut)
        }
        const response = await axios(config)
        logMsg(null, response, 'acceptTerms')
        return {
            error: null,
            response: response
        }
    } catch(e) {
        return {
            error: e,
            response: null
        }
    }
}

export async function runCreateCredentialsServicePrincipal (projectName, orgId, ut, awsCustomerId) {
    try {
        // Get org
        if (!ut) {
            logAlert(new Error('Please sign in.'))
            return null
        }

        // Create credential
        const credential = await createCredentialServicePrincipal(orgId, projectName, ut)
        logMsg(null, credential, 'credential')
        if (credential && credential.status === STATUS_CODE_SUCCESS_CREATED) {
            const intId = credential.data.id
            // Subscribe Entp Integration To Services  api/organizations/{orgId}/integrations/entp/{intId}/services
            const subscription = await putSubscription(orgId, intId, process.env.REACT_APP_CONFIG_APP_CONSOLE_PSAPI_SERVICE_CODE, ut, awsCustomerId)
            logMsg(null, subscription, 'subscription')
            if (subscription && subscription.status === STATUS_CODE_SUCCESS_OK) {
                const project = await getProject(orgId, projectName, ut)
                if (project && project.status === STATUS_CODE_SUCCESS_OK) {
                    const secret = await getClientSecret(orgId, intId, ut)
                    if (secret && secret.data.client_secrets.length > 0 && secret.status === STATUS_CODE_SUCCESS_OK) {
                        return {
                            apiKey: credential.data.apiKey,
                            orgId: orgId,
                            organization: credential.data.orgId,
                            technicalAccountId: credential.data.technicalAccountId,
                            projectName: projectName,
                            projectId: project.id,
                            intId: intId,
                            credential: credential,
                            clientSecret: secret.data.client_secrets[0],
                            status: credential.status
                        }
                    } else {
                        secret.message = 'Failed to get secret'
                        return secret
                    }
                } else {
                    return project
                }
            } else {
                return subscription
            }
        }
        return credential
    } catch (e) {
        return e
    }
}

export async function pData (uInfo, endpoint) {
    try {
        logMsg(null, 'SENDING FORM INFO')
        const tzoffset = (new Date()).getTimezoneOffset() * 60000;
        const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
        uInfo.push({
            name: 'timestamp',
            value: localISOTime.replace(/[TZ]/g, ' ').split('.')[0].trim()
        })
        const counter = 'easybake'
        const body = { data: uInfo };
        const resp = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        const text = await resp.text();
        logMsg(null, uInfo, 'pData, uInfo');
        return resp
    } catch(e) {
        return e
    }
}

export async function deleteApi (endpoint, ut) {
    try {
        const config = {
            method: 'DELETE',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/${endpoint}`,
            headers: getHeader(ut)
        }
        const res = await axios(config)
        return res
    } catch (e) {
        return false
    }
}

export async function putSubscription (orgId, integrationsId, serviceId, ut, awsCustomerId) {
    try {
        const config = {
            method: 'PUT',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/integrations/entp/${integrationsId}/services`,
            headers: getHeader(ut),
            data: {
                sdkCode: serviceId
            }
        }
        if (awsCustomerId) {
            config.data.atlasPlanCode = process.env.REACT_APP_CONFIG_APP_AWS_MP_ALTAS_PLAN_CODE
        }
        const res = await axios(config)
        return res
    } catch (e) {
        return e
    }
}

// api/organizations/{orgId}/projects
export async function createProject (orgId, projectName, ut) {
    try {
        const name = `Project ${getDate()}`
        const config = {
            method: 'POST',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/projects`,
            headers: getHeader(ut),
            data: {
                name: name,
                title: projectName,
                who_created: 'eb',
                description: '',
                type: 'default'
            }
        }
        const res = await axios(config)
        return res
    } catch (e) {
        return e
    }
}

// api/organizations/{orgId}/projects
export async function getProject (orgId, projectName, ut) {
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/projects`,
            headers: getHeader(ut),
        }
        const res = await axios(config)
        const currentProject = res.data.filter((project) => {
            if (project.title === projectName) {
                project.status = res.status
                return project
            }
        })
        return currentProject ? currentProject[0] : false
    } catch (e) {
        return e
    }
}

// api/organizations/{orgId}/policy/{policy}/usage?sdkCode=CIS SDK
export async function getQuota (ut, orgId, policyId) {
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/policy/${policyId}/usage?sdkCode=CIS%20SDK`,
            headers: getHeader(ut),
        }
        const res = await axios(config)
        return res
    } catch (e) {
        return e
    }
}

// api/organizations/{orgId}/integrations/{intId}/secrets
export async function getClientSecret (orgId, intId, ut) {
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/integrations/${intId}/secrets`,
            headers: getHeader(ut),
        }
        const res = await axios(config)
        return res
    } catch (e) {
        return e
    }
}

// api/organizations/{orgId}/credentials/oauth-server-to-server
export async function createCredentialServicePrincipal (orgId, projectName, ut) {
    try {
        const bodyData = {
            name: projectName,
            description: 'This credential is created by EasyBake'
        }
        const config = {
            method: 'POST',
            url: `${process.env.REACT_APP_CONFIG_APP_CONSOLE_API_ENDPOINT}/api/organizations/${orgId}/credentials/oauth-server-to-server`,
            headers: {
                accept: 'application/json',
                'content-type': 'application/json',
                Authorization: `Bearer ${ut}`,
                'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY
            },
            data: JSON.stringify(bodyData)
        }
        const res = await axios(config)
        return res
    } catch (e) {
        if (e.response && e.response.status && e.response.status === STATUS_CODE_FAIL_CONFLICT) {
            e.message += `  ${projectName} already exists. Please choose a different project name.`
        }
        return e
    }
}

// https://wiki.corp.adobe.com/display/AdobeCloudPlatform/Service+Principals#ServicePrincipals-CreatingaServicePrincipalToken
export async function getSpAccessToken (ut, cred) {
    try {
        const options = {
            clientCredentials: 'client_credentials',
            clientId: cred.apiKey,
            clientSecret: cred.clientSecret.client_secret,
            orgId: cred.organization,
            scopes: 'openid,AdobeID',
            ut: ut,
            apiKey: process.env.REACT_APP_CONFIG_APP_KEY
        }
        if (window.easybake) {
            const res = await window.easybake.parent.getSpAccessToken(options)
            return res
        }
        return false
    } catch (e) {
        return e
    }
}

function delayedReturn(value, delay) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(value);
      }, delay);
    });
  }

export async function apiCall (options, ut) {
    try {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest()
            xhr.open(options.method, options.url)
            xhr.onload = () => {
                return (xhr)
            }
            xhr.onerror = () => {
                return (xhr)
            }
            xhr.ontimeout = e => {
                logMsg(null, 'timeout', 'apiCall')
            }
            xhr.setRequestHeader('X-Api-Key', 'cis_easybake')
            xhr.setRequestHeader('Authorization', `Bearer ${ut}`)
            xhr.timeout = 60000
            xhr.send(options.data)
        })
    } catch (e) {
        return e
    }
}

function getHeader (ut) {
    return {
        'content-type': 'application/json',
        Authorization: `Bearer ${ut}`,
        'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY
    }
}

function getFormHeader (ut) {
    return {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${ut}`,
        'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY
    }
}

export function getDate () {
    const d = new Date()
    return `${d.getFullYear()}${d.getMonth() + 1}${d.getDate()}${d.getHours()}${d.getMinutes()}${d.getSeconds()}`
}

export function sortByProperty (property) {
    return function (a, b) {
        if (a[property] > b[property]) {
            return 1
        } else if (a[property] < b[property]) {
            return -1
        }
        return 0
    }
}

export async function getHello (clientId, clientToken) {
// curl --location --request GET 'https://image-stage.adobe.io/pie/psdService/hello' \
// --header 'X-Api-Key: clientId' \
// --header 'Authorization: Bearer clientToken'
    try {
        const config = {
            method: 'GET',
            url: `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/pie/psdService/hello`,
            headers: {
                Authorization: `Bearer ${clientToken}`,
                'x-api-key': clientId
            }
        }
        const res = await axios(config)
        return res
    } catch (e) {
        return e
    }
}

export async function decodeToken (token) {
    try {
        let b64string = token.split('.')[1]
        let buf
    
        try {
          buf = Buffer.from(b64string, 'base64');
        } catch (e) {
          throw new error('error') //TODO kmikawa
        }
    
        let decoded_token = JSON.parse(buf.toString())
        if (decoded_token['cognito:username']) {
          decoded_token['user_id'] = decoded_token['cognito:username']
        }
        return decoded_token
    } catch (e) {
        return e
    }
}

function logDetail (title, msg, res) {
    return; //TODO
    try {
        console.log('**************************************')
        console.log(`${title.toUpperCase()}: `)
        if (Array.isArray(msg)) {
            msg.forEach(m => {
                console.log(JSON.stringify(m, null, 2))
            })
        } else {
            console.log(msg)
        }
        console.log('**************************************')
        if (res) {
            console.log(JSON.stringify(res, null, 2))
        }
    } catch (e) {
        alert(e)
    }
}
